import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {addIcons} from 'ionicons';
import {SplashScreen} from '@capacitor/splash-screen';
import {StatusBar, Style} from '@capacitor/status-bar';
import {EdgeToEdge} from '@capawesome/capacitor-android-edge-to-edge-support';
import {Storage} from '@ionic/storage-angular';
import {Device} from '@capacitor/device';
import {FormsModule} from '@angular/forms';
import {
  IonApp,
  IonRouterOutlet,
  MenuController,
  Platform,
  ToastController
} from '@ionic/angular/standalone';
import {
  calendarOutline,
  hammer,
  help,
  informationCircleOutline,
  logIn,
  logOut,
  mapOutline,
  moonOutline,
  peopleOutline,
  person,
  personAdd
} from 'ionicons/icons';
import {ConfigService} from './core/services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [IonRouterOutlet, IonApp, FormsModule],
  providers: [MenuController, ToastController],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private storage = inject(Storage);
  private menu = inject(MenuController);
  private platform = inject(Platform);
  configService = inject(ConfigService);

  constructor() {
    this.initializeApp();
    addIcons({
      calendarOutline,
      peopleOutline,
      mapOutline,
      informationCircleOutline,
      person,
      help,
      logOut,
      logIn,
      personAdd,
      moonOutline,
      hammer
    });
  }

  async ngOnInit() {
    await this.storage.create();
    await this.configService.loadConfig();
    document.documentElement.classList.toggle(
      'ion-palette-dark',
      this.configService.config().darkMode
    );
    const deviceInfo = await Device.getInfo();
    if (deviceInfo.platform === 'android') {
      // Color de fondo de barra de navegación y de estado
      await EdgeToEdge.setBackgroundColor({color: '#000000'});
      // Color de texto de la barra de estado
      await StatusBar.setStyle({
        style: Style.Dark
      });
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('hybrid')) {
        SplashScreen.hide();
      }
    });
  }

  openTutorial() {
    this.menu.enable(false);
    this.storage.set('ion_did_tutorial', false);
    this.router.navigateByUrl('/tutorial');
  }
}
